import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Button from '../../../../../../components/global/Button';
import { UPDATE_ROSTER_IDENTITY_MODAL } from '../../../../../../constants/modals';
import InputGroup from '../../../../../../components/global/InputGroup';
import SearchIcon from '../../../../../../components/icons/SearchIcon';
import UserAddIcon from '../../../../../../components/icons/UserAddIcon';
import ImportIcon from '../../../../../../components/icons/ImportIcon';
import { ADDRESS_BOOOK_CSV_UPLOAD_MODAL } from '../AddressBookCSVUpload';
import useWaldogramsForBusinessEvent from '../../../../services/analytics/useWaldogramsForBusinessEvent';

const propTypes = {
  onFilterUpdate: PropTypes.func.isRequired,
  filter: PropTypes.shape({
    offset: PropTypes.number.isRequired,
    limit: PropTypes.number.isRequired,
    page: PropTypes.number.isRequired,
  }).isRequired,
  openModal: PropTypes.func.isRequired,
  onSelectableToggle: PropTypes.func,
  selectable: PropTypes.bool,
  canSelect: PropTypes.bool,
};

const AccountAddressBookHeader = ({
  onFilterUpdate,
  filter,
  openModal,
  onSelectableToggle,
  selectable,
  canSelect,
}) => {
  const [searchQuery, setSearchQuery] = useState('');
  const trackEvent = useWaldogramsForBusinessEvent();

  const onSubmit = event => {
    event.preventDefault();

    if (searchQuery !== filter.searchQuery) {
      onFilterUpdate({ searchQuery, page: 0, offset: 0 });
    }
  };

  return (
    <div className="address-book-header">
      <form onSubmit={onSubmit} className="address-book-search-form">
        <InputGroup
          id="address-book-search"
          name="addressBookSearch"
          type="text"
          label="Search your contacts"
          placeholder="Search your contacts"
          labelSrOnly
          addon={<SearchIcon color="#ced6e4" size={14} />}
          value={searchQuery}
          size="sm"
          onChange={event => {
            setSearchQuery(event.target.value);
          }}
        />

        <Button type="submit" btnSize="sm">
          Search
        </Button>
      </form>

      <div className="address-book-header-actions">
        <Button
          btnStyle="link"
          className="d-flex align-items-center"
          onClick={() => {
            openModal(UPDATE_ROSTER_IDENTITY_MODAL, {
              modalTitle: 'Create Contact',
            });
          }}
        >
          <UserAddIcon color="#0d84fe" size={14} className="mr-1" />{' '}
          <span className="d-none d-md-inline-block">Create contact</span>
          <span className="d-inline-block d-md-none">Create</span>
        </Button>

        <Button
          onClick={() => {
            openModal(ADDRESS_BOOOK_CSV_UPLOAD_MODAL);
            trackEvent({
              action: 'CSV Upload',
              label: 'Address Book',
            });
          }}
          btnStyle="link"
          className="d-flex align-items-center ml-1"
        >
          <ImportIcon color="#0d84fe" size={14} className="mr-1" />
          <span className="d-none d-md-inline-block">Import contacts</span>
          <span className="d-inline-block d-md-none">Import</span>
        </Button>

        {canSelect && onSelectableToggle && (
          <Button
            btnStyle="link"
            className="d-flex align-items-center ml-1"
            onClick={onSelectableToggle}
          >
            {selectable ? 'Cancel selection' : 'Send Waldograms'}
          </Button>
        )}
      </div>
    </div>
  );
};

AccountAddressBookHeader.propTypes = propTypes;

export default AccountAddressBookHeader;
